// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_aiX","cls2":"CiterightMiniReport-cls2_xMx CiterightMiniReport-cls1_aiX"};